import { Button, Component, Label, Toggle, _decorator } from 'cc';
import Dropdown from '../../../Components/Dropdown/Dropdown';
import ColorTargetDropdown from '../ColorTargetDropdown';

export interface IBaseColorAdjusterInfo {
    name: string;
}

const { ccclass, property } = _decorator;

@ccclass('BaseColorAdjusterView')
export default abstract class BaseColorAdjusterView<T extends Component = any> extends Component {
    @property
    public readonly displayName: string = '';

    @property
    private readonly targetClassName: string = '';

    @property(Label)
    private readonly titleLabel: Label = null;

    @property(Button)
    private readonly hideButton: Button = null;

    @property(Toggle)
    private readonly enableToggle: Toggle = null;

    @property(Button)
    private readonly resetButton: Button = null;

    @property(ColorTargetDropdown)
    private readonly targetDropdown: ColorTargetDropdown<T> = null;

    public get currentTarget(): T {
        return this.targetDropdown.currentTarget;
    }

    public get isEnabled(): boolean {
        return this.enableToggle.isChecked;
    }
    public set isEnabled(value: boolean) {
        this.enableToggle.isChecked = value;
    }

    protected onLoad() {
        this.resetButton.on(Button.EventType.CLICK, this.reset, this);
        this.targetDropdown.on(Dropdown.EVENT_TYPE.SELECTED_OPTION_CHANGED, this.syncUIWithTarget, this);
        this.hideButton.on(Button.EventType.CLICK, () => {
            this.node.active = false;
        });
        this.enableToggle.on(Toggle.EventType.TOGGLE, () => {
            if (this.currentTarget) {
                this.currentTarget.node.active = this.enableToggle.isChecked;
            }
        });
        this.titleLabel.string = this.displayName || this.node.name;
        this.targetDropdown.targetClassName = this.targetClassName;
    }

    protected start() {
        this.syncUIWithTarget();
    }

    public abstract collectAdjustInfo(): IBaseColorAdjusterInfo;
    protected abstract apply(): void;
    protected abstract syncUIWithTarget(): void;
    protected abstract reset(): void;
}
